
<nav  class="footColor mb-0 py-0 float-center mt-auto navbar navbar-expand-sm  navbar-light sticky-bottom">
  <app-footer-link [menuType] = "'floatingFooter'" [site]=site> </app-footer-link>
</nav>
